export default __webpack_public_path__ + "static/media/paymentTutorial_pc_top_Cn.d27f845a.webp";